import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { useState } from 'react';
import { SwitchStyled, TooltipStyled } from 'src/components';
import { useCurrentUser, useUpdateSettings } from 'src/hooks';

export const Settings = () => {
  const { user } = useCurrentUser();
  const [requireUsersToChooseApprovers, setRequireUsersToChooseApprovers] =
    useState(user?.subscription.orgSettings?.namedApprovers ?? false);
  const [multiLayerApprovals, setMultiLayerApprovals] = useState(
    user?.subscription.orgSettings?.multiLayerApproval ?? false,
  );

  const { mutate: updateSettings, isPending } = useUpdateSettings();
  const isAdmin = user?.subscription.role === 'admin';

  const handleSave = () => {
    updateSettings({
      namedApprovers: requireUsersToChooseApprovers,
      multiLayerApproval: multiLayerApprovals,
    });
  };

  return (
    <>
      {!isAdmin && (
        <h3 className='text-300 text-rose-500'>
          Only Admins in your organization can change these settings
        </h3>
      )}
      <ul className='grid w-full max-w-[400px] grid-cols-2 items-center justify-center gap-4'>
        <li className='col-span-2 flex flex-row flex-nowrap items-center justify-between gap-2'>
          <label className='flex flex-row flex-nowrap items-center justify-center gap-1'>
            Require Users to Select Approver
            <TooltipStyled title='When a user submits a cart for approval, they will be required to select an approver from the list of approvers and admins in your organization.'>
              <div className='flex h-[22.4px] items-center justify-center fill-offGray hover:fill-gray-300'>
                <HelpOutlineIcon style={{ fontSize: 20, fill: 'inherit' }} />
              </div>
            </TooltipStyled>
          </label>
          <SwitchStyled
            checked={requireUsersToChooseApprovers}
            onChange={() =>
              setRequireUsersToChooseApprovers(!requireUsersToChooseApprovers)
            }
            disabled={isPending || !isAdmin}
          />
        </li>
        <li className='col-span-2 flex flex-row flex-nowrap items-center justify-between gap-2'>
          <label className='flex flex-row flex-nowrap items-center justify-center gap-1'>
            Multi-Layer Approvals
            <TooltipStyled title='When an approver approves a cart, they have the option to send the cart to another approver for additional approval.'>
              <div className='flex h-[22.4px] items-center justify-center fill-offGray hover:fill-gray-300'>
                <HelpOutlineIcon style={{ fontSize: 20, fill: 'inherit' }} />
              </div>
            </TooltipStyled>
          </label>
          <SwitchStyled
            checked={multiLayerApprovals}
            onChange={() => setMultiLayerApprovals(!multiLayerApprovals)}
            disabled={isPending || !isAdmin}
          />
        </li>
      </ul>
      <div>
        <button
          onClick={handleSave}
          disabled={isPending || !isAdmin}
          className='button-primary h-12'
        >
          Save
        </button>
      </div>
    </>
  );
};
